import AboutDevice from './Device'
import HomeDevicesGuard from './HomeDevicesGuard'

export const DEVICES_ROUTES = [
  {
    component: AboutDevice,
    path: ':id',
    title: 'Device',
  },
  {
    component: HomeDevicesGuard,
    path: '',
    title: 'Home Devices',
  },
]
